import StepAwayBackground from "assets/StepAwayBackground";
import { Button, Modal } from "reactstrap";
import styles from './staywithus.module.css';
import StepAwayGirl from "assets/StepAwayGirl";
import CloseIcon from "assets/CloseIcon";
export default function StayWithUs({
    isOpen,
    onClick,
    onClose
}) {
    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            centered
            size="lg"
        >
            <div className={`p-3 d-flex flex-row gap-4 align-items-center ${styles.responsiveWidth}`}>
                <div className={`flex-column border border-0 rounded py-1 mx-1 px-4  ${styles.IconContainer}`}>
                    <StepAwayBackground />
                </div>
                <div className='flex-column'>
                    <p className={styles.title}>Stay with Us! 🎉</p>
                    <p className={styles.subtitle}>Hey there! We see you browsing and we’ve got a treat for you!</p>

                    <div className={styles.MwebContainer}>
                        <StepAwayGirl className={styles.ImageMweb} />
                    </div>
                    <div className={styles.contentContainer}>
                                <div className={styles.contentTitle}>
                                Pay registration fee and get access to Aakash exclusive course content
                                </div>
                                <div className={styles.contentSubtitle}>
                                Why stick around?
                            </div>
                        
                        <div className={styles.content}>
                            Freebies like E-books, Audios and Videos!
                        </div>
                    </div>
                    <Button
                        className={`w-100 mt-5 bg-transparent border-blue text-blue ${styles.button} `}
                        onClick={onClick}
                    >
                        Register Now
                    </Button>
                </div>
            </div>
            <Button  className={styles.closeButton} style={{backgroundColor: '#F3F3F3', border: 'none'}}
            onClick={onClose}>
                <CloseIcon/>
            </Button>
        </Modal>
    )
}
